import { render, staticRenderFns } from "./CommonPartDetail.vue?vue&type=template&id=b2037d42"
import script from "./CommonPartDetail.vue?vue&type=script&lang=js"
export * from "./CommonPartDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports